/** Logical uses are not sprites: only textures owns files and image loading. */
export function resolveManifestAssetId(manifest, useKey) {
  const assetId = manifest?.useBindings?.[useKey]?.assetId ?? useKey;
  return Object.prototype.hasOwnProperty.call(manifest?.textures ?? {}, assetId) ? assetId : undefined;
}

/** Resolve one use's effective metadata, including its explicit display override. */
export function resolveManifestTexture(manifest, useKey) {
  const assetId = resolveManifestAssetId(manifest, useKey);
  if (assetId === undefined) return undefined;
  const entry = manifest.textures[assetId];
  const binding = manifest.useBindings?.[useKey];
  if (!binding?.presentation && !binding?.frame) return entry;
  return { ...entry, ...(binding.presentation ? { presentation: binding.presentation } : {}),
    ...(binding.frame ? { frame: binding.frame } : {}) };
}

export function manifestUseKeys(manifest) {
  return [...new Set([...Object.keys(manifest?.textures ?? {}), ...Object.keys(manifest?.useBindings ?? {})])];
}

/** Authoring tools insert logical uses, then rebuild the same file-unique schema. */
export function canonicalizeManifestUses(manifest, uses) {
  const groups = new Map(), textures = {}, useBindings = {};
  for (const [key, entry] of Object.entries(uses)) {
    if (!groups.has(entry.file)) groups.set(entry.file, []);
    groups.get(entry.file).push(key);
  }
  for (const keys of groups.values()) {
    const assetId = keys.find(key => Object.hasOwn(manifest.textures, key)) ?? keys[0];
    const canonical = uses[assetId]; textures[assetId] = canonical;
    for (const key of keys) {
      if (key === assetId) continue;
      const binding = { assetId }, entry = uses[key];
      for (const field of new Set([...Object.keys(canonical), ...Object.keys(entry)])) {
        if (JSON.stringify(canonical[field]) === JSON.stringify(entry[field])) continue;
        if (!['frame', 'presentation'].includes(field) || entry[field] === undefined) throw new Error(`Unsupported shared-asset metadata: ${key}.${field}`);
        binding[field] = entry[field];
      }
      useBindings[key] = binding;
    }
  }
  return { ...manifest, textures, useBindings };
}
